import React from 'react';

import { eventFullPropTypeShape } from '../../../../proptypes';

import Meta from '../../../Meta';

/**
 * Event review page meta presentational component.
 */
const EventReviewPageMeta = (event) => {
  const {
    images,
    title,
  } = event;
  const hero = images && images.hero;
  return (
    <Meta
      title={`Review ${title}`}
      facebookImage={hero && hero.facebook}
      twitterImage={hero && hero.twitter}
      robots="noindex"
    />
  );
};

EventReviewPageMeta.propTypes = {
  /**
   * Object of images associated with the event.
   */
  images: eventFullPropTypeShape.images,
  /**
   * String title of the event.
   */
  title: eventFullPropTypeShape.title, // eslint-disable-line react/require-default-props
};

EventReviewPageMeta.defaultProps = {
  images: undefined,
};

export default EventReviewPageMeta;



// WEBPACK FOOTER //
// ./app/src/components/EventReviewPage/components/EventReviewPageMeta/index.jsx